export enum ResultsDisplayType {
  CARDS = 'CARDS',
  TABLE = 'TABLE',
}
